import React, { useEffect, useState } from "react";
import axios from "axios";
import { serverAPI } from "../index";
import {
  Container,
  HStack,
  Button,
  RadioGroup,
  Radio
} from "@chakra-ui/react";
import Loader from "./Loader";
import ErrorComponent from "./ErrorComponent";
import CoinsCard from "./CoinsCard";

const Coins = () => {
  const [coins, SetCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [currency, setCurrency] = useState("inr"); //default/initally currency is inr

  const currencySymbol =
    currency === "inr" ? "₹" : currency === "eur" ? "€" : "$";

  const changePage = (pageNo) => {
    setPage(pageNo);
    setLoading(true); //also show loading when changing page
  };

  //there are almost list of 13200 around coins on https://api.coingecko.com
  // i.e on 132 page so we will make 132 buttons
  const btns = new Array(132).fill(1);

  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const { data } = await axios.get(
          serverAPI + `/coins/markets?vs_currency=${currency}&page=${page}`
        );
        SetCoins(data);
        //console.log(data)
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchCoins();
  }, [currency, page]); //so when currency/page changes it fetchs data again/it re-renders

  if (isError) return <ErrorComponent message={"Error While Fetching Coins"} />;

  return (
    <Container maxW={"container.xl"}>
      {loading ? (
        <Loader />
      ) : (
        <>
        {/*for selecting currency */}
        <RadioGroup value={currency} onChange={setCurrency} p={"8"}>
          {/*here in onChange we don't have to mention e.target.value , as chakra ui will does it
          automatically , it will put selected value in setCurrency */}
          <HStack spacing={"4"}>
            <Radio value="inr">INR</Radio>
            <Radio value="usd">USD</Radio>
            <Radio value="eur">EUR</Radio>
          </HStack>
        </RadioGroup>

          <HStack wrap={"wrap"} justifyContent={"space-evenly"}>
            {coins.map((i) => (
              <CoinsCard
                id={i.id}
                key={i.id}
                name={i.name}
                price={i.current_price}
                img={i.image}
                symbol={i.symbol}
                currencySymbol={currencySymbol}
              />
            ))}
          </HStack>

          <HStack w={"full"} overflowX={"auto"} p={"5"}>
            {/* <Button bgColor={"blackAlpha.900"} color={"white"} onClick={()=>changePage(2)}>2</Button> */}
            {btns.map((item, index) => (
              <Button
              key={index}
                bgColor={"blackAlpha.900"}
                color={"white"}
                onClick={() => changePage(index + 1)}
              >
                {index + 1}
              </Button>
            ))}
          </HStack>
        </>
      )}
    </Container>
  );
};

export default Coins;
